// frontend/src/components/Common/Footer.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaHeart,
  FaGithub,
  FaArrowUp,
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Handle newsletter subscription
      console.log('Newsletter subscription:', email);
      setEmail('');
      // Show success message
      alert('Thank you for subscribing to our newsletter!');
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Back to Top Button */}
        <button className="back-to-top" onClick={scrollToTop} aria-label="Back to top">
          <FaArrowUp />
        </button>
        
        {/* Main Footer Content */}
        <div className="footer-grid">
          
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-icon">🏆</span>
              <span className="logo-text">SportsCoach</span>
            </div>
            <p className="footer-description">
              Connecting athletes with professional coaches for personalized training 
              and skill development. Your journey to excellence starts here.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FaGithub />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/sports">Sports</Link></li>
              <li><Link to="/facilities">Facilities</Link></li>
              <li><Link to="/coaches">Find Coaches</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          {/* For Coaches */}
          <div className="footer-section">
            <h3 className="footer-heading">For Coaches</h3>
            <ul className="footer-links">
              <li><Link to="/coach/register">Become a Coach</Link></li>
              <li><Link to="/coach/dashboard">Coach Dashboard</Link></li>
              <li><Link to="/coach/resources">Resources</Link></li>
              <li><Link to="/coach/community">Community</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/help/coaches">Help Center</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact Us</h3>
            <ul className="contact-info">
              <li>
                <FaEnvelope className="contact-icon" />
                <a href="mailto:support@sportscoach.com">support@sportscoach.com</a>
              </li>
              <li>
                <FaPhone className="contact-icon" />
                <a href="tel:+11234567890">+1 (123) 456-7890</a>
              </li>
              <li>
                <FaMapMarkerAlt className="contact-icon" />
                <span>123 Sports Avenue, City, Country 12345</span>
              </li>
            </ul>
            
            <div className="newsletter">
              <h4 className="newsletter-title">Stay Updated</h4>
              <p className="newsletter-description">
                Subscribe to our newsletter for the latest updates.
              </p>
              <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <input
                  type="email"
                  placeholder="Your email"
                  className="newsletter-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="newsletter-btn">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              &copy; {currentYear} SportsCoach. All rights reserved.
              <span className="made-with">
                Made with <FaHeart className="heart-icon" /> for the sports community.
              </span>
            </div>
            
            <div className="footer-legal">
              <Link to="/privacy">Privacy Policy</Link>
              <span className="divider">•</span>
              <Link to="/terms">Terms of Service</Link>
              <span className="divider">•</span>
              <Link to="/cookies">Cookie Policy</Link>
              <span className="divider">•</span>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;